import type { ReportSnapshotSummaryDto } from "@/api/dtos";
import type { ReportSnapshotSummary } from "@/api/report/_models/ReportUpload";

/** DTO → domain for a built snapshot's summary. */
export const toReportSnapshotSummaryFromDto = (dto: ReportSnapshotSummaryDto): ReportSnapshotSummary => {
  return {
    key: dto.key,
    date: dto.date,
    size: dto.size,
    builtAt: dto.builtAt,
  };
};
